import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-restaurant-price-rating',
  templateUrl: './restaurant-price-rating.component.html',
  styleUrls: []
})
export class RestaurantPriceRatingComponent implements OnInit {
  @Input() priceRating:number;
  constructor() { }
  ngOnInit() {}
}
